// extracted by mini-css-extract-plugin
export default {"wrapper":"_eaf5e120","endingSoon":"_15a4c41"};